export default {
    header: "Ordres de {name}",
    error: "Une erreur s'est produite",
    empty: "Aucune commande trouvée",
    system: "Service d'assistance",
    orders: {
        name: "Nom",
        date: "Date",
        status: "Statut",
        approvedBy: "Approuvé par"
    },
    cta: {
        close: "Fermer"
    }
}